import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import GeometryDirectionalMoveCmd from "./GeometryDirectionalMoveCmd";

// Drags the extrusion-depth edit handle of an ExtrudedLoopAnnotationSceneObject (Area/Rectangle/
// Circle) along its extrusion normal. All drag math/pointer handling is inherited unchanged from
// GeometryDirectionalMoveCmd (single-axis-projected movement) — this subclass exists only to give
// the interaction its own command id and i18n resource keys.
export default class ExtrudedLoopAreaSetExtrusionDepthCmd extends GeometryDirectionalMoveCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.ExtrudedLoopAreaSetExtrusionDepth;
        this.commandNameResourceKey = 'command.extrudedLoopAreaSetExtrusionDepth.title';
        this.initialPrompResourceKey = 'command.extrudedLoopAreaSetExtrusionDepth.prompt';
    }
}
